import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastService } from '../toast.service';
import { UserType } from '../user-type.enum';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  roles = ['Admin', 'Distributor', 'Staff'];
  selectedRole = '';
  email = '';
  password = '';
  passwordVisible = false;

  loading = false;
  errorMsg = '';

  constructor(
    private router: Router,
    private http: HttpClient,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    if (localStorage.getItem('token')) {
      this.router.navigate(['/dashboard']);
      return;
    }
    this.extractRoleFromURL();
  }

  extractRoleFromURL() {
    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0].toLowerCase();

    // Map subdomain to role (works for both production and localhost)
    if (subdomain === UserType.Admin.toLowerCase() || subdomain === "admin-dev") {
      this.selectedRole = UserType.Admin;
    } else if (subdomain === UserType.Distributor.toLowerCase() || subdomain === "distributor-dev") {
      this.selectedRole = UserType.Distributor;
    } else if (subdomain === UserType.Staff.toLowerCase() || subdomain === "staff-dev") {
      this.selectedRole = UserType.Staff;
    } else {
      // Default fallback for regular localhost or 127.0.0.1
      this.selectedRole = UserType.Admin;
    }
  }

  togglePassword() {
    this.passwordVisible = !this.passwordVisible;
  }

  signIn() {
    this.errorMsg = '';
    this.loading = true;
    const payload = {
      email: this.email,
      password: this.password,
      role: this.selectedRole.toLowerCase()
    };
    this.http.post<any>(`${environment.apiBaseUrl}/auth/login`, payload).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data?.token) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('user', JSON.stringify(res.data.user));
          localStorage.setItem('isLoggedIn', 'true');
          this.toastService.success('Login successful!');
          this.router.navigate(['/dashboard']);
        } else {
          this.errorMsg = res.message || 'Login failed';
          this.toastService.error(res.message || 'Login failed');
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Login failed';
        this.toastService.error(err?.error?.message || 'Login failed');
      }
    });
  }
}
